import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Avatar,
} from '@lockerpm/design';

import common from '../../utils/common';

function UserAvatar(props) {
  const {
    size = 32,
    showInfo = true,
    nameClassName = ''
  } = props;
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state.auth.userInfo);
  const locale = useSelector((state) => state.system.locale);
  const teams = useSelector((state) => state.enterprise.teams);
  const plan = useSelector((state) => state.payment.plan);

  const planName = useMemo(() => {
    return common.displayPlanName();
  }, [plan])

  const roleDisplay = useMemo(() => {
    if (teams?.length === 0) {
      return planName ? t(planName) : userInfo?.email
    }
    const role = common.getUserRole(teams[0]?.role) 
    return `${teams[0]?.name} - ${t(role?.label)}`
  }, [teams, userInfo, locale, plan])

  return (
    <div className='flex items-center w-full'>
      {
        userInfo?.avatar && <Avatar
          size={size}
          src={userInfo.avatar}
        >
          {userInfo.email.slice(0, 1)?.toUpperCase()}
        </Avatar>
      }
      {
        !userInfo?.avatar && <Avatar
          size={size}
          style={{
            backgroundColor: 'var(--sidebar-menu-group-color)',
            color: 'var(--sidebar-menu-active-background-color)'
          }}
        >
          {userInfo?.name?.slice(0, 1)?.toUpperCase() || 'S'}
        </Avatar>
      }
      {
        showInfo && <div
          className='account-info ml-2 text-start'
          style={{ width: `calc(100% - ${size}px - 8px)` }}
        >
          <div
            className={`font-semibold w-full text-limited ${nameClassName}`}
            style={{ display: 'block' }}
            title={userInfo?.name}
          >
            {userInfo?.name}
          </div>
          <p
            className='text-black-500 w-full text-limited'
            style={{ display: 'block' }}
            title={roleDisplay}
          >
            {roleDisplay}
          </p>
        </div>
      }
    </div>
  );
}

export default UserAvatar;
